module.exports = __webpack_public_path__ + "components/flag/static/square/es-70d897ff8a5b5dd34161085457451a08.svg";